import {Directive, Injectable, Signal, signal} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {TranslateService} from "@ngx-translate/core";
import {firstValueFrom} from "rxjs";

@Directive({standalone: true})
@Injectable({providedIn: 'root'})
export class CustomTitleDirective  {
  private defualtTitle: Signal<string> = signal('Administracion');

  constructor(private titleService: Title,
              private _t: TranslateService) {  }

  changeTitle(title: string): void {
    firstValueFrom(this._t.get(title))
      .then((value: string) => {
        this.titleService.setTitle(value);
      }).catch((err: Error) => {
      this.titleService.setTitle(this.defualtTitle());
    });
  }
}
